import { xchacha20poly1305 } from '@noble/ciphers/chacha';
import { randomBytes } from '@noble/ciphers/webcrypto';
/**
 * Encrypt plaintext with XChaCha20-Poly1305.
 * Key must be 32 bytes, nonce must be 24 bytes.
 * The authentication tag is appended to the ciphertext by @noble/ciphers.
 */
export function encrypt(key, nonce, plaintext) {
    if (key.length !== 32) {
        throw new Error(`Key must be 32 bytes, got ${key.length}`);
    }
    if (nonce.length !== 24) {
        throw new Error(`Nonce must be 24 bytes, got ${nonce.length}`);
    }
    return xchacha20poly1305(key, nonce).encrypt(plaintext);
}
/**
 * Decrypt ciphertext with XChaCha20-Poly1305.
 * Throws if the auth tag does not verify (wrong key, wrong nonce, or tampered data).
 */
export function decrypt(key, nonce, ciphertext) {
    if (key.length !== 32) {
        throw new Error(`Key must be 32 bytes, got ${key.length}`);
    }
    if (nonce.length !== 24) {
        throw new Error(`Nonce must be 24 bytes, got ${nonce.length}`);
    }
    return xchacha20poly1305(key, nonce).decrypt(ciphertext);
}
/**
 * Generate a fresh 24-byte nonce from CSPRNG.
 * Each ciphertext MUST use a unique nonce.
 */
export function generateNonce() {
    return randomBytes(24);
}
//# sourceMappingURL=cipher.js.map